import COLORS from '@/constants/colors';
import { useIsMobile } from '@/utils/isMobile';
import { Transition } from '@/utils/Transitions';
import { Dialog } from '@mui/material';
import { useState } from 'react';
import { OrderResumeHeader } from '../OrderResumeHeader/OrderResumeHeader';
import { OrderResumeSection } from '../OrderResumeSection/OrderResumeSection';

export function OrderResumeDialog() {
  const [open, setOpen] = useState(false);
  const isMobile = useIsMobile();

  return (
    <>
      <Dialog open={open} fullScreen TransitionComponent={Transition}>
        <OrderResumeSection closeClicked={() => setOpen(false)} />
      </Dialog>
      {isMobile && (
        <OrderResumeHeader
          onClick={() => setOpen(true)}
          sx={{
            position: 'absolute',
            bottom: 0,
            border: `1px solid ${COLORS.gray_6}`,
            borderTopLeftRadius: '12px',
            borderTopRightRadius: '12px',
            width: '100%',
            justifyContent: 'center',
            marginTop: '16px',
          }}
        />
      )}
    </>
  );
}
